import React, { useEffect } from "react";
import "./MicrosoftButton.css";
import { useMicrosoftLoginCustom } from "../../hooks/useMicrosoftLoginCustom";
// Warning : This button is design by Microsoft and is not customizable
// Took the button from the official microsoft button documentation
// Link : https://learn.microsoft.com/en-us/entra/identity-platform/howto-add-branding-in-apps
const MicrosoftButton = ({ onError, onSubmitSuccess, setLoader }) => {
  const { handleLogin, error } = useMicrosoftLoginCustom(onSubmitSuccess);

  // Propage the error to the parent component
  useEffect(() => {
    if (onError) {
      onError(error);
    }
  }, [error, onError]);

  return (
    <button
      className="ms-login-button"
      onClick={() => {
        setLoader(true);
        handleLogin();
      }}
    >
      <div className="ms-logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
        >
          <title>MS-SymbolLockup</title>
          <rect x="1" y="1" width="9" height="9" fill="#f25022" />
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
          <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
          <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
      </div>
      <span className="ms-login-text">Se connecter avec Microsoft</span>
    </button>
  );
};

export default MicrosoftButton;
